import { create } from 'zustand';

interface RenderFormStateProps {
    formData: any;
    showForm: boolean;
    handleShowForm: (value: boolean) => void;
    setFormData: (value: any) => void;
}

const useRenderFormStore = create<RenderFormStateProps>((set) => ({
    formData: null,
    showForm: false,
    handleShowForm: (value: boolean) => set({ showForm: value }),
    setFormData: (value: any) => set({ formData: value }),
}));

export default useRenderFormStore;